import PropTypes from 'prop-types'
import React from 'react'
import WideLayout from 'layouts/WideLayout'
import FaqLayoutHeader from 'modules/Faq/layouts/FaqLayoutHeader'
import faqStyles from 'modules/Faq/styles/Faq.module.scss'

const FaqWideLayout = ({ children = null }) => (
  <WideLayout
    className={faqStyles['faq-wide-layout']}
    hasCloseButton={false}
    header={<FaqLayoutHeader />}
  >
    {children}
  </WideLayout>
)

FaqWideLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
}

export default FaqWideLayout
